import styled from '@emotion/styled';
import { COLORS } from '../../constants/radar';

export const Container = styled.div`
  padding: 24px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BACKGROUND_PRIMARY};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: ${COLORS.SECONDARY};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${COLORS.BACKGROUND};
    color: ${COLORS.PRIMARY};
    transform: translateX(-2px);
  }

  svg {
    font-size: 16px;
  }
`;

export const Title = styled.h1`
  color: ${COLORS.PRIMARY};
  font-size: 24px;
  margin: 0;
  font-weight: 600;
  position: relative;
  padding-left: 16px;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 24px;
    width: 4px;
    background-color: ${COLORS.PRIMARY};
    border-radius: 2px;
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BACKGROUND_SECONDARY};
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: white;
  padding: ${props => props.$show ? '16px 24px' : '0 24px'};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  opacity: ${props => props.$show ? 1 : 0};
  max-height: ${props => props.$show ? '200px' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
  transform-origin: top;
  transform: ${props => props.$show ? 'scaleY(1)' : 'scaleY(0)'};
  margin-bottom: ${props => props.$show ? '24px' : '0'};

  .MuiOutlinedInput-root {
    height: 40px;
    font-size: 14px;
  }

  .MuiSelect-select {
    padding: 8px 12px;
  }

  .MuiInputLabel-root {
    transform: translate(12px, 8px) scale(1);
    font-size: 14px;
    
    &.Mui-focused,
    &.MuiFormLabel-filled {
      transform: translate(12px, -9px) scale(0.75);
    }
  }
`; 

export const Panel = styled.div`
  background-color: white;
  border-radius: 6px;
  padding: 24px;
  height: 100%;
  overflow: auto;
`; 

export const MainSection = styled.div`
  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: auto;
`;

export const HeaderButton = styled.button`
  padding: 8px 16px;
  background-color: white;
  color: ${COLORS.PRIMARY};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  white-space: nowrap;
  opacity: ${props => props.disabled ? 0.6 : 1};
  
  &:hover {
    background-color: ${props => props.disabled ? 'white' : COLORS.PRIMARY};
    color: ${props => props.disabled ? COLORS.PRIMARY : 'white'};
    transform: ${props => props.disabled ? 'none' : 'translateY(-1px)'};
    box-shadow: ${props => props.disabled ? '0 2px 4px rgba(0, 0, 0, 0.05)' : '0 4px 8px rgba(0, 0, 0, 0.1)'};
  }

  &:active {
    transform: ${props => props.disabled ? 'none' : 'translateY(0)'};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: ${props => props.disabled ? 'none' : 'scale(1.1)'};
  }
`; 

export const MainContainer = styled.div`
  width: 100%;
  height: calc(100vh - 250px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
  margin-top: ${props => props.$show === false ? '0' : '24px'};
  transition: all 0.3s ease;

  svg {
    width: 800px;
    height: 800px;
    max-height: 100%;
  }
`;